import Crud from '@/views/WorkSchedule/Crud'

const routes = {
  path: '/workschedule',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/workschedule',
      name: 'Lista Escala de Trabalho',
      component: Crud,
    },
  ],
}

export default routes
